/**
 * Query keys: The signed-in user and their preferences. Owned by the session/current-user migration.
 *
 * Keys are arrays that start with a stable domain prefix so `invalidateQueries`
 * can target a whole domain by prefix. Put every input the response depends on
 * (account, user, portfolio ids, filters, date range) into the key.
 */
export const sessionKeys = {
  all: ['session'],
  /** `GET /api/user`, parsed. The cookie session decides which user it is. */
  currentUser: () => [...sessionKeys.all, 'currentUser'],
  /** `GET /api/user/preferences/all` for one signed-in user. */
  preferences: (userId) => [...sessionKeys.all, 'preferences', userId ?? null],
}
